import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { useLang } from "../contexts/LanguageContext";
import { Droplets, Ruler, Fish } from "lucide-react";

const FALLBACK = [
  "https://images.unsplash.com/photo-1770130870606-db8e48d9777e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxzZXJlbmUlMjBsYWtlJTIwcmVzb3J0JTIwbmF0dXJlfGVufDB8fHx8MTc3ODk0MDYyNHww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1654099602420-c90791787b79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxzZXJlbmUlMjBsYWtlJTIwcmVzb3J0JTIwbmF0dXJlfGVufDB8fHx8MTc3ODk0MDYyNHww&ixlib=rb-4.1.0&q=85",
];

export default function Lakes() {
  const { t, pick, lang } = useLang();
  const [lakes, setLakes] = useState([]);

  useEffect(() => {
    api.get("/lakes").then((r) => setLakes(r.data)).catch(() => {});
  }, []);

  return (
    <div className="py-20 md:py-32 container-deg" data-testid="lakes-page">
      <div className="max-w-2xl mb-16">
        <div className="overline">02 · {t("nav.lakes")}</div>
        <h1 className="font-serif text-5xl md:text-6xl mt-4 text-balance">{t("lakes.heading")}</h1>
        <p className="text-ink-soft mt-6 leading-relaxed text-lg">{t("lakes.sub")}</p>
      </div>

      <div className="space-y-24">
        {lakes.map((lk, i) => (
          <div key={lk.id} className={`grid grid-cols-1 lg:grid-cols-12 gap-10 items-center ${i % 2 ? "" : ""}`} data-testid={`lake-${i}`}>
            <div className={`lg:col-span-7 ${i % 2 ? "lg:order-2" : ""}`}>
              <div className="aspect-[4/3] overflow-hidden">
                <img src={lk.image_base64 || FALLBACK[i % FALLBACK.length]} alt={pick(lk, "name")} className="w-full h-full object-cover" />
              </div>
            </div>
            <div className={`lg:col-span-5 ${i % 2 ? "lg:order-1" : ""}`}>
              <div className="overline">Lake 0{i + 1}</div>
              <h2 className="font-serif text-4xl md:text-5xl mt-3">{pick(lk, "name")}</h2>
              <p className="text-ink-soft mt-6 leading-relaxed">{pick(lk, "description")}</p>

              <div className="grid grid-cols-2 gap-6 mt-10 border-t border-line pt-8">
                <div>
                  <div className="flex items-center gap-2 text-secondary mb-2">
                    <Droplets size={16} strokeWidth={1.5} />
                    <span className="overline text-xs">{t("lakes.area")}</span>
                  </div>
                  <div className="font-serif text-2xl text-primary">{lk.area_hectares} <span className="text-sm text-ink-soft">{t("lakes.hectares")}</span></div>
                </div>
                <div>
                  <div className="flex items-center gap-2 text-secondary mb-2">
                    <Ruler size={16} strokeWidth={1.5} />
                    <span className="overline text-xs">{t("lakes.depth")}</span>
                  </div>
                  <div className="font-serif text-2xl text-primary">{lk.max_depth_m} <span className="text-sm text-ink-soft">{t("lakes.meters")}</span></div>
                </div>
              </div>

              <div className="mt-8">
                <div className="flex items-center gap-2 text-secondary mb-3">
                  <Fish size={16} strokeWidth={1.5} />
                  <span className="overline text-xs">{t("lakes.species")}</span>
                </div>
                <div className="flex flex-wrap gap-2">
                  {(lang === "hu" ? lk.fish_species_hu : lk.fish_species_en).map((s) => (
                    <span key={s} className="px-3 py-1 border border-line text-xs">{s}</span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
